import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import PropTypes from "prop-types";
import {
  clearOrderDetails,
  fetchOrderDetails
} from "../../../state/user/actions";
import { USER } from "../../../constants";
import eventType from "../../../prop-types/eventType";
import { Template } from "../../../commons/elements";
import OrderDetails from "../components/order-details";
import "../styles/order-details.scss";

const propTypes = {
  types: PropTypes.arrayOf(eventType).isRequired
};

function OrderDetailsContainer({ types }) {
  const dispatch = useDispatch();
  const orderDetails = useSelector((state) => state.user.orderDetails);
  const params = useParams();
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    dispatch(fetchOrderDetails(params.orderId));
    return () => dispatch(clearOrderDetails());
  }, []);

  useEffect(() => {
    setIsLoading(!orderDetails);
  }, [orderDetails]);

  return (
    <Template types={types} tabName={USER} isLoading={isLoading}>
      <OrderDetails orderDetails={orderDetails} />
    </Template>
  );
}

OrderDetailsContainer.propTypes = propTypes;

export default OrderDetailsContainer;
